import { Link } from "react-router-dom";
import { Box, Container, Text } from "@chakra-ui/react";

const Appbar = () => {
    return(
        <Box boxShadow="md" bg="#171717">
            <Container maxW="container.xl" py="3">
            <Link to="/">
                <Text fontSize="lg" color="#ffffff" fontWeight="600">
                    GOALcrush
                </Text>
            </Link>
            </Container>  
        </Box>
    );
}

export default Appbar;